import React, { useState } from "react";
import { Button } from "../../../../../../design/button";
import {
  Alert,
  AlertActions,
  AlertDescription,
  AlertTitle,
} from "../../../../../../design/alert";
import { useFiling } from "../../../../../../contexts/FilingContext";
import { Filing } from "../../../../../../models/Filing";
import { FilingSection } from "../../../../../../models/FilingSection";
import { useAuth } from "../../../../../../contexts/AuthContext";
import {
  DropdownMenu,
  DropdownButton,
  DropdownItem,
  Dropdown,
  DropdownSection,
} from "../../../../../../design/dropdown";
import { EllipsisHorizontalIcon } from "@heroicons/react/20/solid";
import { Comment } from "../../../../../../models/Comment";

interface Props {
  filing: Filing;
  section: FilingSection;
  comment: Comment;
}

const SectionCommentMoreButton: React.FC<Props> = ({
  filing,
  section,
  comment,
}) => {
  const { user } = useAuth();
  const { deleteComment } = useFiling();
  const [isAlertOpen, setIsAlertOpen] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);

  if (!user || comment.createdBy !== user.uid) return null;

  const handleDelete = async () => {
    setIsDeleting(true);
    try {
      await deleteComment(filing._id, section._id!, comment._id!);
      setIsAlertOpen(false);
    } catch (error) {
      console.error("Error deleting comment:", error);
      alert("Failed to delete comment. Please try again later.");
    }
    setIsDeleting(false);
  };

  const handleDropdownItemPressed = (type: string) => {
    switch (type) {
      case "delete":
        setIsAlertOpen(true);
        break;
      default:
        console.log("Unknown action type:", type);
    }
  };

  return (
    <>
      {/* ALERT FIRST */}
      <Alert open={isAlertOpen} onClose={setIsAlertOpen}>
        <AlertTitle>Delete Comment</AlertTitle>
        <AlertDescription>
          Are you sure you want to delete this comment? This action cannot be
          undone.
        </AlertDescription>
        <AlertActions>
          <Button
            plain
            onClick={() => setIsAlertOpen(false)}
            disabled={isDeleting}
          >
            Cancel
          </Button>
          <Button color="red" onClick={handleDelete} disabled={isDeleting}>
            Delete
          </Button>
        </AlertActions>
      </Alert>

      {/* DROPDOWN TRIGGER */}
      <Dropdown>
        <DropdownButton plain>
          <EllipsisHorizontalIcon className="w-4 h-4 text-muted" />
        </DropdownButton>
        <DropdownMenu>
          <DropdownSection>
            <DropdownItem
              onClick={() => handleDropdownItemPressed("delete")}
              className="text-red-600 hover:bg-red-50"
            >
              Delete
            </DropdownItem>
          </DropdownSection>
        </DropdownMenu>
      </Dropdown>
    </>
  );
};

export default SectionCommentMoreButton;
